export default 'M15 3a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-6 8a3 3 0 1 1 6 0v10a3 3 0 1 1-6 0z';